export default {"src":"/_next/static/media/discord.45099135.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};